var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',[_vm._v("提现账号")])
}
var staticRenderFns = []

export { render, staticRenderFns }